import { useMemo, useState } from "react";
import { Box, Button, Card, CardContent, Stack, TextField, Typography } from "@mui/material";
import { toast } from "sonner";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ROUTES } from "../../router/constants";
import { resetPassword } from "../../services/passwordReset.service";

export function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = useMemo(() => searchParams.get("token") || "", [searchParams]);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    try {
      setLoading(true);
      await resetPassword({ token, password, confirmPassword });
      toast.success("Senha redefinida com sucesso. Faça login novamente.");
      navigate(ROUTES.SIGNIN);
    } catch (e: any) {
      const msg = e?.response?.data?.message || e?.message;
      toast.error(msg ? String(msg) : "Falha ao redefinir senha");
    } finally {
      setLoading(false);
    }
  };

  const tokenMissing = !token;

  return (
    <Box sx={{ width: "100vw", height: "100vh", display: "flex", alignItems: "center", justifyContent: "center", p: 2 }}>
      <Card sx={{ width: "100%", maxWidth: 520 }}>
        <CardContent>
          <Stack spacing={2}>
            <Typography variant="h6" fontWeight={700} color="#133859">
              Redefinir senha
            </Typography>

            {tokenMissing ? (
              <Typography color="error">
                Token inválido. Solicite novamente a recuperação de senha.
              </Typography>
            ) : (
              <>
                <TextField
                  label="Nova senha"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  fullWidth
                />
                <TextField
                  label="Confirmar senha"
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  fullWidth
                />

                <Stack direction={{ xs: "column", sm: "row" }} spacing={1} justifyContent="flex-end">
                  <Button variant="text" color="inherit" onClick={() => navigate(ROUTES.SIGNIN)} disabled={loading}>
                    Voltar
                  </Button>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading || !password || !confirmPassword}
                  >
                    {loading ? "Salvando..." : "Salvar"}
                  </Button>
                </Stack>
              </>
            )}
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
